module.exports = __webpack_public_path__ + "img/video-avtar1.6a3196e0.png";